import {
  OAuthIntegrationPairingModal
} from './OAuthIntegrationPairingModal';
import {
  notionService
} from "../services/api";
import {
  OnboardingEvents
} from '../analytics/posthog';

interface NotionPairingModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
  existingLabels?: string[];
}

export function NotionPairingModal({
  isOpen,
  onClose,
  onSuccess,
  existingLabels,
}: NotionPairingModalProps) {
  return (
    <OAuthIntegrationPairingModal
      isOpen={isOpen}
      onClose={onClose}
      onSuccess={onSuccess}
      existingLabels={existingLabels}
      name="notion"
      displayName="Notion"
      description="Connect your Notion workspace so the assistant can search, read, and update your pages and databases."
      features={[
        'Search pages and databases',
        'Read docs, notes, and meeting content',
        'Create pages and database entries',
        'Update properties, blocks, and tasks',
      ]}
      accentColor="slate"
      events={{
        modalOpened: OnboardingEvents.NOTION_MODAL_OPENED,
        oauthStarted: OnboardingEvents.NOTION_OAUTH_STARTED,
        connected: OnboardingEvents.NOTION_CONNECTED,
        connectionFailed: OnboardingEvents.NOTION_CONNECTION_FAILED,
        modalClosed: OnboardingEvents.NOTION_MODAL_CLOSED,
      }}
      service={notionService}
    />
  );
}
